import { render } from "./CourseProductInfo.vue?vue&type=template&id=41aeb315&scoped=true"
import script from "./CourseProductInfo.vue?vue&type=script&lang=js"
export * from "./CourseProductInfo.vue?vue&type=script&lang=js"

import "./CourseProductInfo.vue?vue&type=style&index=0&id=41aeb315&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aeb315"]])

export default __exports__